import React, { FunctionComponent, ReactNode } from "react";
import { 
  TableHead, 
  TableBody, 
  TableRow, 
  TableCell,
  TableSortLabel
} from "@mui/material";
import styles from "./PaginatedTable.module.css"; 
// Utilizing existing table styles, or we could pass styles/classes as props

export interface ColumnDef {
    id: string;
    label: string;
    style?: React.CSSProperties;
    className?: string;
    align?: 'left' | 'center' | 'right' | 'justify' | 'inherit';
    /** When false, header is not clickable (e.g. expand column). Defaults to true when sort props are passed. */
    sortable?: boolean;
}

interface DynamicTableProps {
    columns: ColumnDef[];
    children: ReactNode; // This will be the TableBody content (rows)
    sortColumn?: string | null;
    sortDirection?: "asc" | "desc";
    onRequestSort?: (columnId: string) => void;
}

const DynamicTable: FunctionComponent<DynamicTableProps> = ({
  columns,
  children,
  sortColumn = null,
  sortDirection = "asc",
  onRequestSort,
}) => {
  return (
    <>
        <TableHead className={styles.tableHeader}>
            <TableRow>
                {columns.map((col) => {
                  const sortable =
                    col.sortable !== false &&
                    Boolean(onRequestSort) &&
                    Boolean(col.label);
                  return (
                    <TableCell
                      key={col.id}
                      className={col.className || styles.headerCell}
                      style={col.style}
                      align={col.align}
                    >
                      {sortable ? (
                        <TableSortLabel
                          active={sortColumn === col.id}
                          direction={
                            sortColumn === col.id ? sortDirection : "asc"
                          }
                          onClick={() => onRequestSort?.(col.id)}
                          sx={{
                            color: "inherit",
                            "&.MuiTableSortLabel-root": { color: "inherit" },
                            "& .MuiTableSortLabel-icon": {
                              color: "inherit !important",
                              opacity: sortColumn === col.id ? 1 : 0.35,
                            },
                          }}
                        >
                          {col.label}
                        </TableSortLabel>
                      ) : (
                        col.label
                      )}
                    </TableCell>
                  );
                })}
            </TableRow>
        </TableHead>
        <TableBody>
            {children}
        </TableBody>
    </>
  );
};

export default DynamicTable;
